import { Stack } from '@mui/material';

import { DialogMessageBox } from '../components/DialogMessageBox';
import { SuccessCountdownMessage } from '../components/SuccessCountdownMessage';
import type { ApiWorkflowDialogProps } from '../types';

export const ApiWorkflowSubmittedContent = ({
  submittedTitle,
  submittedText,
  renderSubmitted,
  successCountdownTime,
  hideDisplayButtonsOnSuccess,
  onClose,
  onRedirectAfterSubmit,
}: Pick<
  ApiWorkflowDialogProps,
  | 'renderSubmitted'
  | 'successCountdownTime'
  | 'hideDisplayButtonsOnSuccess'
  | 'onClose'
  | 'onRedirectAfterSubmit'
> & { submittedTitle: string; submittedText: string }) => {
  return (
    <Stack gap={4}>
      <DialogMessageBox
        id="submitted"
        title={submittedTitle}
        type="success"
        text={submittedText}
        renderSubmitted={renderSubmitted}
      />
      <SuccessCountdownMessage
        successCountdownTime={successCountdownTime}
        hideDisplayButtonsOnSuccess={hideDisplayButtonsOnSuccess}
        onClose={onClose}
        onRedirectAfterSubmit={onRedirectAfterSubmit}
      />
    </Stack>
  );
};
